export interface TimeProvider {
  now(): Date;
}

export class RealTimeProvider implements TimeProvider {
  now(): Date {
    return new Date();
  }
}

export class SimulatedTimeProvider implements TimeProvider {
  private offset = 0;

  now(): Date {
    return new Date(Date.now() + this.offset);
  }

  advanceDays(days: number): void {
    this.offset += days * 86_400_000;
  }

  reset(): void {
    this.offset = 0;
  }

  getOffset(): number {
    return this.offset;
  }
}
